import { z } from 'zod'

export const YaplaOrganizationNameDonationsEntityZod = z.object({
  organization: z.string(),
})

export const YaplaVillesDesserviesEntityZod = z.object({
  lastname: z.string(),
})

export const YaplaInformationsClientsEntityZod = z.object({
  lastname: z.string(),
  id: z.string(),
})

export type YaplaCustomerRegion = z.infer<typeof YaplaCustomerRegionZod>
export const YaplaCustomerRegionZod = z.object({
  campagne_de_dons: z.string().nullish().default(null),
  campagne_de_dons_en: z.string().nullish().default(null),
  operating_dates: z
    .record(z.string(), z.string())
    .or(z.array(z.unknown()))
    .nullish()
    .transform((arg) => {
      if (Array.isArray(arg)) return {}
      if (!arg) return {}
      return arg
    }),
  sunday_opening_time: z.string().nullish().default(null),
  thursday_opening_time: z.string().nullish().default(null),
  monday_opening_time: z.string().nullish().default(null),
  tuesday_opening_time: z.string().nullish().default(null),
  wednesday_opening_time: z.string().nullish().default(null),
  saturday_opening_time: z.string().nullish().default(null),
  friday_opening_time: z.string().nullish().default(null),
  sunday_closing_time: z.string().nullish().default(null),
  thursday_closing_time: z.string().nullish().default(null),
  monday_closing_time: z.string().nullish().default(null),
  tuesday_closing_time: z.string().nullish().default(null),
  wednesday_closing_time: z.string().nullish().default(null),
  saturday_closing_time: z.string().nullish().default(null),
  friday_closing_time: z.string().nullish().default(null),
  organization_name_donations: YaplaOrganizationNameDonationsEntityZod.array()
    .or(z.string())
    .nullish()
    .transform((arg) => {
      if (!Array.isArray(arg)) return []
      return arg
    }),
  company_name_1: z.string().nullish().default(null),
  company_name_2: z.string().nullish().default(null),
  company_name_3: z.string().nullish().default(null),
  local_cab_number_1: z.string().nullish().default(null),
  local_cab_number_2: z.string().nullish().default(null),
  local_cab_number_3: z.string().nullish().default(null),
  phone_number_1: z.string().nullish().default(null),
  informations_clients: YaplaInformationsClientsEntityZod.array()
    .nullish()
    .transform((arg) => {
      if (!Array.isArray(arg)) return []
      return arg
    }),
  address_state: z
    .string()
    .nullish()
    .transform((arg) => arg ?? ''),
  status: z.string(),
  villes_desservies: YaplaVillesDesserviesEntityZod.array()
    .or(z.string())
    .nullish()
    .transform((arg) => {
      if (!Array.isArray(arg)) return []
      return arg
    }),
})

export const GetCustomerRegionsResponseZod = z.object({
  code: z.number(),
  data: YaplaCustomerRegionZod.array().nullish(),
})

export const YaplaLocalOrganizationZod = z.object({
  id: z.string(),
})

export const YaplaLocalOrganizationEmailZod = z.object({
  email: z.string(),
})

export type YaplaCentral = z.infer<typeof YaplaCentralZod>
export const YaplaCentralZod = z.object({
  firstname: z.string().nullish().default(null),
  no_civique: z.string().nullish().default(null),
  address_address: z.string().nullish().default(null),
  address_city: z.string().nullish().default(null),
  address_state: z.string().nullish().default(null),
  address_zip: z.string().nullish().default(null),
  opening_hours: z.string().nullish().default(null),
  notes: z.string().nullish().default(null),
  id: z.string(),
})

export type YaplaVolunteerRegion = z.infer<typeof YaplaVolunteerRegionZod>
export const YaplaVolunteerRegionZod = z.object({
  organisation_locale: YaplaLocalOrganizationZod.array()
    .or(z.string())
    .nullish()
    .transform((arg) => {
      if (!Array.isArray(arg)) return []
      return arg
    }),
  status: z.string(),
  registration_requirements_en: z.string().nullish().default(null),
  registration_requirements_fr: z.string().nullish().default(null),
  centrales: YaplaCentralZod.array()
    .or(z.string())
    .nullish()
    .transform((arg) => {
      if (!Array.isArray(arg)) return []
      return arg
    }),
  courriel_de_lorganisation_locale: YaplaLocalOrganizationEmailZod.array()
    .or(z.string())
    .nullish()
    .transform((arg) => {
      if (!Array.isArray(arg)) return []
      return arg
    }),
  telephoneinfo: z.string().nullish().default(null),
})

export const GetVolunteerRegionsResponseZod = z.object({
  code: z.number(),
  data: YaplaVolunteerRegionZod.array().nullish(),
})

export const yaplaOpeningHours: Record<string, string> = {
  '501543': '16:00',
  '501544': '16:30',
  '501545': '17:00',
  '501546': '17:30',
  '501547': '18:00',
  '501548': '18:30',
  '501549': '19:00',
  '501550': '19:30',
  '501551': '20:00',
  '501576': '20:30',
  '501577': '21:00',
  '501578': '21:30',
}
